<template>
	<div class="container" v-loading.fullscreen.lock="fullscreenLoading">
		<cnHeader ref="headerRef" @custom-event="getToken"></cnHeader>
		<div class="page_content">
			
			<!--添加客人-开始-->
			<el-dialog
			  title="添加客人"
			  :visible.sync="guestDialog"
			  :destroy-on-close="true"
			  width="500px">
			  <div class="add_guest_box">
			  	<div class="item">
					<span>姓名：</span>
					<input type="text" ref="guest_name" v-model="guest_name" class="inpt" maxlength="50" style="width: 300px;" placeholder="请输入客人姓名" />
				</div>
				<div class="item">
					<span>年龄：</span>
					<el-input-number v-model="guest_age" :min="minAge" :max="maxAge"></el-input-number>
				</div>
				<div class="btns">
					<el-button @click="guestDialog = false" style="width: 30%;">取 消</el-button>
					<el-button type="primary" @click="pushGuest()" style="width: 30%;">确 定</el-button>
				</div>
			  </div>
			</el-dialog>
			<!--添加客人-结束-->
			
			<!--面包屑与公共提醒-开始-->
			<div class="ext_head">
				<div class="bread_crumb">
					<a href="/cn">首页</a><span class="space">/</span><a href="/cn/product">旅游套餐</a><span class="space">/</span>自助下单
				</div>
			</div>
			<!--面包屑与公共提醒-结束-->
			
			<!--页面内容-开始-->
			<div class="booking_box">
				<!--左侧-开始-->
				<div class="bbox_left">
					<h1>自助下单</h1>
					<!--套餐名称-开始-->
					<div class="bk_item">
						<div class="project_title">套餐名称</div>
						<div class="project_right_box">
							<div class="hotel_plan_box">
								<h3>{{productDetail.Title}}</h3>
								<h3>{{productDetail.StrokeDays}}天{{parseInt(productDetail.StrokeDays-1)}}晚</h3>
								<div v-if="productDetail.Attention !=''" class="friendly_tips">{{productDetail.Attention}}</div>
							</div>
						</div>
					</div>
					<!--套餐名称-结束-->
					<!--住宿方案-开始-->
					<div class="bk_item">
						<div class="project_title">住宿方案</div>
						<div class="project_right_box">
							<div class="hotel_plan_box">
								<h3>{{this.planList.Title}}</h3>
								<div v-for="(item, index) in this.planList.Hotels" :key="index">
									<h4>{{item.HotelName}}</h4>
									<h5>{{item.RoomType}} {{item.Nights}}晚</h5>
									<div v-if="item.ChildMinAge !=''"><div class="friendly_tips">{{item.ChildMinAge}}岁(含)以下儿童免收占床费</div></div>
								</div>
							</div>
						</div>
					</div>
					<!--住宿方案-结束-->
					<!--抵达日期-开始-->
					<div class="bk_item">
						<div class="project_title">抵达日期</div>
						<div class="project_right_box">
							<div class="arrival_date_box">
								<el-date-picker
								v-model="bookingDay" 
								type="date" 
								:clearable=false
								:editable=false
								prefix-icon="none" 
								placeholder="选择日期"
								:picker-options="pickerOptions"
								@change="changeDate"
								>
								</el-date-picker>
							</div>
						</div>
					</div>
					<!--抵达日期-结束-->
					
					<!--房间数量与客人-开始-->
					<div class="bk_item">
						<div class="project_title">房间数量</div>
						<div class="project_right_box">
							
							<div class="room_nums">
								<div class="ctrl_box" @click="roomAmountHandle(-1)">-</div>
								<div class="num">{{roomAmount}}</div>
								<div class="ctrl_box" @click="roomAmountHandle(1)">+</div>
							</div>
							<div class="room_items">
								<div class="item" v-for="(item, index) in roomGuestList" :key="index">
									<h3>房间 {{item.room}}<span @click="guestDialogHandle(index)" v-if="item.guest.length<4">添加客人</span></h3>
									<ul v-if="item.guest.length>0">
										<li v-for="(x, y) in item.guest" :key="y">
											<div class="guest">{{x.realName}}，{{x.age}}岁</div>
											<div class="remove" @click="removeGuest(index,y)"></div>
										</li>
									</ul>
									<div v-else class="nothing">
										<p>未添加任何客人</p>
										<!-- <p style="color: #666;">{{childMinAge}}岁(含)以下儿童免收占床费</p> -->
									</div>
								</div>
							</div>
							
						</div>
					</div>
					<!--房间数量与客人-结束-->
					
					<!--备注-开始-->
					<div class="bk_item">
						<div class="project_title">备注信息</div>
						<div class="project_right_box">
							<div class="remark_box">
								<div class="remark_input">
									<el-input type="textarea" 
									:rows="5" 
									placeholder="如需帮助请在此输入您的需求!" 
									maxlength="200" 
									show-word-limit
									v-model="remark">
									</el-input>
								</div>
								<!-- <div class="friendly_tips">如因您提供的航班讯息出错，本公司不承担因此引起的责任。</div> -->
							</div>
						</div>
					</div>
					<!--备注-结束-->
					<!--联系人信息-开始-->
					<div class="bk_item">
						<div class="project_title">联系人信息</div>
						<div class="project_right_box">
							<div class="contact_box">
								<div class="item_box">
									<div class="l_title">姓名</div>
									<input type="text" ref="linkman" v-model="linkman" maxlength="50" class="r_input" placeholder="请输入姓名（必填）" />
								</div>
								<div class="item_box">
									<div class="l_title">手机</div>
									<input type="text" ref="mobile" v-model="mobile" maxlength="20" class="r_input" placeholder="请输入手机号码（必填）" />
								</div>
								<div class="item_box">
									<div class="l_title">邮箱</div>
									<input type="text" ref="email" v-model="email" maxlength="50" class="r_input" placeholder="请输入您的邮箱（必填）" />
								</div>
							</div>
						</div>
					</div>
					<!--联系人信息-结束-->
				</div>
				<!--左侧-结束-->

				<!--右侧-开始-->
				<div class="bbox_right">
					<div class="price_box">
						<div class="price">${{payableTotal}}</div>
						<div class="ext_price">含州税 ${{taxTotal}}</div>
					</div>
					<div class="submit_btn">
						<el-button type="primary" round :loading="btnLoading" @click="submitBooking()">{{btnTxt}}</el-button>
					</div>
				</div>
				<!--右侧-结束-->
			</div>
			<!--页面内容-结束-->
		</div>
		<cnFooter></cnFooter>
	</div>
</template>


<script>
	import moment from 'moment'
	import {
		getProductDetail,
		checkToken,
		getProductPrice,
		submitProductBooking,
	} from '@/api/index.js'
	import {
		mixin
	} from '@/utils/mixin.js'
	import cnHeader from '@/components/cn_header.vue'
	import cnFooter from '@/components/cn_footer.vue'
	export default {
		name: 'CN_ProductBooking',
		mixins: [mixin],
		components: {
			cnHeader,
			cnFooter,
		},
		data() {
			return {
				pickerOptions: {
					disabledDate(time) {
						return time.getTime() < Date.now()+1 * 24 * 60 * 60 * 1000
					},
				},
				bookingDay: Date.now()+2 * 24 * 60 * 60 * 1000,
				
				hotelSubTotal: 0,	//酒店费用
				recreationSubTotal: 0,		//玩乐费用
				taxTotal: 0,	//州税
				payableTotal: 0,	//应付金额
				
				roomAmount: 1,		//房间数量
				roomIndex: 0,		//当前操作的房间索引
				maxOfRoom: 4,		//每个房间最大人数
				childMinAge: 2,		//儿童年龄,小于等于此值免收占床费
				roomGuestList: [
					{
						"room": 1,
						"guest": []
					},
				],	//房间与客人列表
				
				Id: '', //套餐Id
				planId: '', //住宿方案Id
				fullscreenLoading: true, //loading状态
				language: 'cn', //语言版本
				terminal: 'pc', //终端，pc
				loginStatus: false,	//登录态
				token: null, //token
				
				productDetail: [], //详情
				planList: [],		//住宿方案详情
				
				guestDialog: false,	//添加客人弹窗状态
				guest_name: '',
				guest_age: 18,
				minAge: 1,	//最小支持年龄
				maxAge: 120,	//最大支持年龄
				
				linkman: '',	//联系人姓名
				mobile: '',		//联系人手机
				email: '',		//联系人邮箱
				remark:'',		//备注
				
				btnLoading: false,
				btnTxt: '提交订单',
			}
		},
		created() {
			// 验证ProductId
			if (this.$route.query.Id != undefined && this.$route.query.Id !='') {
				this.Id = this.$route.query.Id
			}
			else{
				this.$message.error('Id不能为空');
			}
			
			//验证PlanId
			if (this.$route.query.PlanId != undefined && this.$route.query.PlanId !='') {
				this.planId = this.$route.query.PlanId
			}
			else{
				this.$message.error('PlanId不能为空');
			}
			
			// 验证BookingDate
			if(this.$route.query.BookingDate !=undefined && this.$route.query.BookingDate !='')
			{
				if(!isNaN(new Date(this.$route.query.BookingDate).getTime()))
				{
					this.bookingDay = new Date(this.$route.query.BookingDate+'T00:00:00').getTime()
				}
			}		
		},
		methods: {
			//接收组件回传Token
			getToken(token)
			{
				this.token = token
				if(this.token !=null && this.token !='')
				{
					this.loginStatus = true
				}
				// 获取详情
				this.getData()
				
				// this.token = token
				// if(this.token !=null && this.token !='')
				// {
				// 	this.loginStatus = true
					
				// 	this.getData()
				// }
				// else {
				// 	//跳转至登录页
				// 	this.$router.push({
				// 		path: '/cn/user/login?ReturnUrl=' + encodeURIComponent(window.location.href)
				// 	})
				// }
			},
			//获取数据
			async getData() {
				const { data: res } = await getProductDetail(this.language, this.Id, this.formattedDate(this.bookingDay), this.terminal, this.token)
				this.fullscreenLoading = false
				if (res.errcode === 0) {
					this.productDetail = res.data
					this.getPlanList(this.productDetail.Plans)
				} else {
					this.$message.error(res.errmsg);
				}
			},
			//获取住宿方案详情
			getPlanList(plans)
			{
				for (let item of plans) {
					if(item.PlanId == this.planId)
					{
						this.planList = item
						break;
					}
				}
			},
			//选定日期
			async changeDate()
			{
				//获取价格
				this.getPrice()
			},
			// 获取价格
			async getPrice()
			{
				this.fullscreenLoading = true
				//组装请求数据
				let params={
					Language: this.language,
					Terminal: this.terminal,
					Token: this.token,
					PlanId: this.planId,
					BeginDate: this.formattedDate(this.bookingDay),
					Rooms: this.roomGuestList,
				}
				
				const { data: res } = await getProductPrice(params)
				this.fullscreenLoading = false
				if (res.errcode === 0) {
					
					this.hotelSubTotal = parseFloat(res.data.HotelSubTotal)
					this.recreationSubTotal = parseFloat(res.data.RecreationSubTotal)
					this.taxTotal = parseFloat(res.data.TaxTotal)
					this.payableTotal = parseFloat(res.data.Total)
					
				} 
				else
				{
					this.hotelSubTotal = 0
					this.recreationSubTotal = 0
					this.taxTotal = 0
					this.payableTotal = 0
				}
				
				console.log('计算完成')
			},
			
			//房间数量操作
			roomAmountHandle(i)
			{
				if(i==-1)
				{
					//减
					if(this.roomAmount == 1) 
					{
						return
					}
					else
					{
						this.roomAmount--
						this.roomGuestList.splice(this.roomAmount, 1)
					}
				}
				else if(i==1)
				{
					//加
					if(this.roomAmount < 10)
					{
						this.roomAmount++
						let param = {
							room: this.roomAmount,
							guest: [],
						}
						this.roomGuestList.push(param)
					}
					else
					{
						return
					}
				}				
				//计算金额
				this.getPrice()
			},
			// 添加客人
			guestDialogHandle(roomIndex)
			{
				this.guest_name = ''
				this.guest_age = 18
				this.guestDialog = true
				this.roomIndex = roomIndex
			},
			// 保存客人
			pushGuest()
			{
				if(this.guest_name == '')
				{
					this.$message.error('请输入客人姓名')
					this.$refs.guest_name.focus()
					return
				}				
				this.guestDialog = false
				
				let guestParams = {
					realName: this.guest_name,
					age: this.guest_age,
				}
				this.roomGuestList[this.roomIndex].guest.push(guestParams)
				
				//计算金额
				this.getPrice()
			},
			// 移除客人
			removeGuest(a,b)
			{
				this.roomGuestList[a].guest.splice(b, 1)				
				//计算金额
				this.getPrice()
			},
			//判断是否有房间中没有客人
			checkGuestCount()
			{
				let res = true
				for (let item of this.roomGuestList) {
					if(item.guest.length ==0 )
					{
						res = false
						break;
					}
				}
				return res
			},
			// 提交表单
			async submitBooking()
			{
				if(!this.loginStatus)
				{
					//调用头部组件中的登录方法
					this.$refs.headerRef.showHandleBox('login')
				}
				else
				{					
					if(this.btnLoading)
					{
						return
					}
					
					if(this.bookingDay =='')
					{
						this.$message.error('请选择抵达日期。')
						return
					}
					
					if(!this.checkGuestCount())					
					{
						this.$message.error('对不起，房间内未添加任何客人。')
						return
					}				
					
					if(this.payablePrice == 0)
					{
						this.$message.error('订单金额错误。')
						return
					}
					
					if(this.linkman == '')
					{
						this.$message.error('请输入联系人姓名。')
						this.$refs.linkman.focus()
						return
					}
					if(this.mobile == '')
					{
						this.$message.error('请输入联系人手机号码。')
						this.$refs.mobile.focus()
						return
					}
					if(this.email == '')
					{
						this.$message.error('请输入联系人邮箱。')
						this.$refs.email.focus()
						return
					}
					const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
					if (!emailPattern.test(this.email)) {
						this.$message.error('联系人邮箱格式错误。')
						this.$refs.email.focus()
						return
					}
					
					this.btnLoading = true
					this.btnTxt = "提交中，请稍侯..."
					this.fullscreenLoading = true
					
					//组装请求数据
					let params={
						ProductId: this.Id,
						PlanId: this.planId,
						Token: this.token,
						Terminal: this.terminal,
						Language: this.language,
						BookingDate: moment(this.bookingDay).format('YYYY-MM-DD'),
						LinkMan: this.linkman,
						Mobile: this.mobile,
						Email: this.email,
						Remark: this.remark,
						TotalPrice: (this.hotelSubTotal+this.recreationSubTotal).toFixed(2),
						TaxRatePrice: this.taxTotal,
						PayablePrice: this.payableTotal,
						Rooms: this.roomGuestList,
					}
					
					const { data: res } = await submitProductBooking(params)
					this.fullscreenLoading = false
					if (res.errcode === 0) {
						this.$router.push({
							path: '/cn/user/booking_success?OrderNo='+res.data.OrderNo
						})
					} else {
						this.btnLoading = false
						this.btnTxt = "提交订单"
						this.fullscreenLoading = false
						this.$message.error(res.errmsg);
					}
				}
			},
		}
	}
</script>

<style lang="less" scoped>
	.container {
		width: 100%;
		box-sizing: border-box;
		
		/*添加客人*/
		.add_guest_box {
			
			.item {
				margin: 20px 0;
				
				span {
					color: #111;
					display: inline-block;
					margin-right: 6px;
				}
				
				.inpt {
					height: 42px;
					line-height: 42px;
					font-size: 15px;
					box-sizing: border-box;
					padding: 0 6px;
					border: #999 solid 1px;
					outline: 0;
				}
				::placeholder {
					color: #bbb;
				}
			}
			.btns {
				text-align: right;
			}
		}
	}
	
	
	.submit_btn {
		margin-top: 40px;
	}
	
	
	.el-select {
		width: 100%;
	}
	
	.el-button {
		width: 100%;
		font-family: "PingFang SC", sans-serif, Helvetica, Arial;
		font-size: 15px;
		font-weight: 400;
		height: 42px;
		border-radius: 21px;
		-webkit-transition: all .3s ease;
	}
	.el-button--default {
		border: #666 solid 1px;
		color: #666;
		margin-left: 20px;
	}
	.el-button--default:hover {
		border: #3D7856 solid 1px;
		color: #3D7856;
	}
	.el-button.is-plain:focus  {
		border: #3D7856 solid 1px;
		color: #3D7856;
	}
	
	.el-button--primary {
		border: 0;
	}		
	.el-button--primary:focus {
		background-color: #3D7856;
	}
	.el-button--primary:hover {
		background-color: #000;
	}
</style>